import { Building, Landmark, MapPin, UserCheck } from "lucide-react";

export const TIERS = {
  owner: { label: "Owner credential", icon: UserCheck, cls: "bg-purple-50 text-purple-700 border-purple-200" },
  federal: { label: "Federal", icon: Landmark, cls: "bg-blue-50 text-blue-700 border-blue-200" },
  state: { label: "State", icon: Building, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  local: { label: "Local / city", icon: MapPin, cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export function TierBadge({ tier }) {
  const t = TIERS[tier] || TIERS.local;
  const Icon = t.icon;
  return <span className={`inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest px-1.5 py-0.5 rounded border ${t.cls}`}><Icon className="h-3 w-3" />{t.label}</span>;
}
